export default "__VITE_ASSET__KgUSHbi6__"